import {
  CardActionArea as MuiCardActionArea,
  CardActionAreaProps as MuiCardActionAreaProps,
  styled,
} from "@mui/material";

import { brandColors } from "../../utils/brand-colors";

const StyledSelectableCard = styled(MuiCardActionArea)(({ theme, disabled }) => {
  return {
    width: "22rem",
    borderRadius: "1rem",
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    color: theme.palette.selectableCard.color,
    backgroundColor: disabled
      ? theme.palette.mode === "dark"
        ? theme.palette.grey[800]
        : theme.palette.grey[100]
      : theme.palette.selectableCard.backgroundColor,
    border: `${brandColors.cardBorderNormalColor} solid`,
    borderWidth: "2px",
    "&:hover": {
      border: disabled
        ? `${brandColors.cardBorderNormalColor} solid`
        : `2px solid ${theme.palette.mutinexMagenta.main}`,
      backgroundColor: disabled
        ? theme.palette.mode === "dark"
          ? theme.palette.grey[900]
          : theme.palette.grey[100]
        : theme.palette.selectableCard.hoverBackgroundColor,
    },
    "& .MuiTypography-root": {
      opacity: disabled ? 0.6 : 1,
      color: disabled && theme.palette.mode === "dark" ? theme.palette.grey[100] : "inherit",
    },
    "& .MuiListItemIcon-root": {
      opacity: disabled ? 0.5 : 1,
    },
    "& .IconContainer": {
      opacity: disabled ? 0.5 : 1,
    },
  };
});

const StyledDiv = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  };
});

interface SelectableCardProps extends MuiCardActionAreaProps {
  children: React.ReactNode;
}

export const SelectableCard: React.FC<SelectableCardProps> = ({ children, ...props }) => {
  return (
    <StyledSelectableCard {...props}>
      <StyledDiv>{children}</StyledDiv>
    </StyledSelectableCard>
  );
};

export default SelectableCard;
